
import MicroModal from 'micromodal';  // es6 module


class SlideShow {
  slideIndex = 1;

  constructor(selector){
    this.mainComponent = document.querySelector(selector);
    this.slides = this.mainComponent.querySelectorAll('.slideshow-slides');
    this.dots = this.mainComponent.querySelectorAll('.dot');
    this.showSlides(1);
  }

  updateDots = ()=>{
    if (this.mainComponent.querySelector('.modal__btn.next-slide'))
      if (this.slideIndex>=3) {
        this.mainComponent.querySelector('.modal__btn.next-slide').hidden = true;
      }else {
        this.mainComponent.querySelector('.modal__btn.next-slide').hidden = false;
      }
  }

  showSlides = (n)=>{
    let i;
    if (n > this.slides.length) {this.slideIndex = 1}
    if (n < 1) {this.slideIndex = this.slides.length}
    for (i = 0; i < this.slides.length; i++) {
      this.slides[i].style.display = 'none'
    }
    for (i = 0; i < this.dots.length; i++) {
      this.dots[i].className = this.dots[i].className.replace(' active', '');
    }
    this.slides[this.slideIndex-1].style.display = 'block'
    this.dots[this.slideIndex-1].className += ' active';
    this.updateDots();
  };

  nextSlide = ()=>{
    this.showSlides(this.slideIndex+=1);
    this.updateDots();
  };



}

let desktopSlider,mobileSlider;

const init = () => {
  desktopSlider = new SlideShow(".slideshow-container.desktop-only");
  mobileSlider = new SlideShow(".slideshow-container.mobile-only");
};

window.ModelViewerUtil = {
  init,
  handleModelViewerShow: () => {
    MicroModal.show('model-viewer');
  },
  handleModelViewerClose: () => {
    MicroModal.close('model-viewer');
  },
  handleModelViewerInstructionShow: () => {
    desktopSlider.showSlides(desktopSlider.slideIndex = 1);
    mobileSlider.showSlides(mobileSlider.slideIndex = 1);
    MicroModal.show('model-viewer-instructions');
  },
  handleModelViewerInstructionClose: () => {
    MicroModal.close('model-viewer-instructions');
  },
  plusSlides:()=>{
    desktopSlider.nextSlide();
    mobileSlider.nextSlide();
  },
  currentSlide:(n)=>{
    desktopSlider.showSlides(desktopSlider.slideIndex = n);
    mobileSlider.showSlides(mobileSlider.slideIndex = n);
  }
}

function initParentScrollLocking(){
  const targetNode = document.getElementById('model-viewer');
  if (!targetNode) return;

  const config = { attributes: true, childList: false, subtree: false };

  const callback = function(mutationList) {
      for(const mutation of mutationList) {
          if (mutation.type === 'attributes') {
            if (targetNode.classList.contains('is-open')){
              document.body.style.overflow = 'hidden';
              if (document.querySelector('#launcher'))
                document.querySelector('#launcher').parentElement.classList.add('hidden')
            }else{
              document.body.style.overflow = 'scroll';
              if (document.querySelector('#launcher'))
                document.querySelector('#launcher').parentElement.classList.remove('hidden')
            }
          }
      }
  };

  const observer = new MutationObserver(callback);

  observer.observe(targetNode, config);
}

initParentScrollLocking();

export default window.ModelViewerUtil
